import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const DrinksMixologySection = () => {
  return (
    <section className="py-16 bg-muted/30 pt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-12 items-center">
          {/* Image - Now on the left */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative">

            <div className="relative rounded-2xl overflow-hidden shadow-warm-xl">
              <Image
                src="/assets/images/DSC04838-1767723834090.jpg"
                alt="Elegant cocktail with gold rim garnish against dark sophisticated background"
                className="w-full aspect-square md:aspect-auto md:h-[400px] object-cover object-[center_62%] md:object-center" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            </div>
          </motion.div>

          {/* Content - Now on the right */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center sm:text-left">

            <div className="inline-flex items-center space-x-2 bg-accent/10 px-4 py-2 rounded-full mb-4">
              <Icon name="Wine" size={20} className="text-accent" />
              <span className="text-accent font-body font-medium">DRINKS & MIXOLOGY</span>
            </div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-6">
              Craft <span className="text-primary">Cocktails</span> & More
            </h2>

            <p className="text-lg text-muted-foreground font-body mb-8 leading-relaxed">
              From classic margaritas to innovative craft cocktails, our drink menu complements every meal. Fresh ingredients, bold flavors, expertly mixed.
            </p>

            <a
              href="https://drive.google.com/file/d/1IaCoBWg1awgR1K-mMhs7nYbQZgbLT0Fa/preview"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-accent text-accent-foreground hover:bg-accent/90 px-8 py-3 text-lg font-semibold rounded-lg shadow-warm hover:shadow-warm-lg transition-all duration-300">

              View Drink Menu
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );

};

export default DrinksMixologySection;